import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-konfig-pill',
  standalone: true,
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="konfig-pill" data-testid="konfig-pill" [attr.title]="configuration()">
      <span class="konfig-pill__dot" aria-hidden="true"></span>
      <span class="sr-only">{{ ('testRun.configuration' | translate) + ': ' }}</span>
      <span class="konfig-pill__label">{{ configuration() }}</span>
    </span>
  `,
  styles: `
    :host {
      display: inline-flex;
      max-width: 100%;
      min-width: 0;
    }

    .konfig-pill {
      display: inline-flex;
      align-items: center;
      gap: 0.4375rem;
      padding: 0.3125rem 0.6875rem;
      border-radius: 999px;
      font-size: 0.75rem;
      font-weight: 600;
      white-space: nowrap;
      box-sizing: border-box;
      max-width: 100%;
      min-width: 0;
      background: var(--to-neutral-bg);
      color: var(--to-neutral-fg);
    }

    .konfig-pill__label {
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .konfig-pill__dot {
      width: 0.375rem;
      height: 0.375rem;
      border-radius: 50%;
      flex-shrink: 0;
      background: var(--to-neutral-dot);
    }
  `,
})
export class KonfigPillComponent {
  readonly configuration = input.required<string>();
}
